import { Input } from "@mui/material";
import React from "react";

const CodeInput = ({
  handleOnChange,
  value,
  disabled,
}: {
  handleOnChange: (e: any) => void;
  value: string;
  disabled: boolean;
}) => {
  return (
    <Input
      placeholder="Enter Code"
      onChange={handleOnChange}
      value={value}
      sx={{
        padding: "5px 20px",
        gap: "8.384px",
        flexShrink: " 0",
        width: "100%",
        borderRadius: "10px",
        opacity: " 0.8",
        background: "#EFF3F4",
      }}
      disabled={disabled}
    />
  );
};
export default CodeInput;
